import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

/**
 * GPT 플랜(Codex) 실행 방식 API (정형화 설계 13-4·13-8절, 요청서 30절).
 * 상태는 실행기(runner)가 30초마다 DB 에 쓰는 신호를 api 가 읽어 주고, 로그인·취소·로그아웃만 실행기로 넘어간다.
 * 토큰·비밀번호는 이 화면이 다루지 않는다. 로그인은 device-auth 주소·코드뿐이다.
 */

export type CodexModel = { slug: string; displayName: string; defaultEffort: string | null; efforts: string[] };
export type CodexLoginPending = { url: string; code: string; startedAt: string; expiresAt: string };
export type CodexLoginLast = { ok: boolean; at: string; error: string | null };
export type RunnerRow = {
  id: string;
  name: string;
  url: string;
  status: "online" | "offline";
  lastSeenAt: string;
  running: number;
  concurrency: number;
  codexVersion: string | null;
  loggedIn: boolean;
  accountLabel: string | null;
  lastError: string | null;
  createdAt: string;
  loginMethod?: string | null;
  defaultModel?: string | null;
  models?: CodexModel[];
  loginPending?: CodexLoginPending | null;
  lastLogin?: CodexLoginLast | null;
};
export type CodexStatus = {
  runner: Omit<RunnerRow, "loginMethod" | "defaultModel" | "models" | "loginPending" | "lastLogin"> | null;
  installed: boolean;
  version: string | null;
  loggedIn: boolean;
  method: string | null;
  lastCheckedAt: string | null;
  error: string | null;
  defaultModel: string | null;
  models: CodexModel[];
  login: CodexLoginPending | null;
  lastLogin: CodexLoginLast | null;
  provider: "api" | "codex";
  model: string;
  effort: string;
  timeoutSec: number;
};

export const codexKeys = {
  status: ["admin", "llm", "codex", "status"] as const,
  runners: ["admin", "llm", "runners"] as const,
};

/** 상태: 보통 30초(실행기 신호 간격), 로그인 진행 중이면 5초. */
export function useCodexStatus(enabled: boolean, fast = false) {
  return useQuery({ queryKey: codexKeys.status, enabled, queryFn: () => api.get<CodexStatus>("/admin/llm/codex/status"), refetchInterval: fast ? 5_000 : 30_000 });
}

export function useRunners(enabled: boolean) {
  return useQuery({ queryKey: codexKeys.runners, enabled, queryFn: () => api.page<RunnerRow>("/admin/llm/runners"), refetchInterval: 30_000 });
}
